import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { UploadButton, ComponentsKreditdataRedirectButton, InfoDialog, Button, Spacer } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { uploadFile } from 'store/actions/file';
import { Routes } from 'utils/routes';
import { mediaQueries, untilSmallMediaQuery, untilTabletMediaQuery } from 'utils/MediaQueriesDeprecated';
import getConfig from 'next/config';
import { hasRateLimitPeriodExpired, rateLimitPeriodExpiresInDays } from 'utils/uniifyUtils';

const { publicRuntimeConfig: { kreditDataIntegration, scraperIntegration } } = getConfig();

const UploadPensionModal = ({ closeModal }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const history = user?.integrations?.kreditdata?.history?.length ? user?.integrations?.kreditdata?.history : user?.integrations?.kreditdata ? [{ ...user?.integrations?.kreditdata, type: 'PensionsInfoFile' }] : [];
    const fileType = 'PensionsInfoFile';
    const canUseUniify = hasRateLimitPeriodExpired(history, fileType);
    const showHelpText = !!user?.integrations?.kreditdata; // documents.filter(x => x.fileType === 'PensionsInfoFile' && x.content?.source === 'api').length > 0;
    const onFilesChoosenHandler = files => {
        const file = files[0];
        dispatch(uploadFile([file], [], fileType));
        closeModal(false);
    };
    const daysUntilExpiration = useMemo(() => kreditDataIntegration && rateLimitPeriodExpiresInDays(history, fileType),[history]);
    const buttonText2 = mediaQueries(untilSmallMediaQuery) ? 'Hent nye oplysninger' : 'Hent nye pensionsoplysninger';
    const buttonSize = mediaQueries(untilTabletMediaQuery) ? 'tiny' : 'medium';
    const refetchPensionsInfoFromUniify = () =>{
        const { publicRuntimeConfig:{ uniify } } = getConfig();
        const customerId = user?.integrations?.kreditdata?.customer_id;
        if (customerId) {
            window.location.assign(`${window.location.href.replace('?continueOrder=true','')}?kreditdata_id=${customerId}&kreditdata_state=submitted`);
        } else {
            Alert('Der er noget galt, prøv igen senere');
        }

    };


    // debug override
    // kreditDataIntegration = false;

    return (
        <InfoDialog modal={ true } showClose={ true } onClose={ closeModal }
            headerContent={ <h3>{ buttonText2 }</h3> }
            modalContent={
                <>
                    { kreditDataIntegration ? (
                        canUseUniify.hasExpired ? (
                            <div style={{ marginTop: 20, marginBottom: 20 }}>
                                <p>
                                    Når du henter nye oplysninger vil du blive bedt om at logge på med MitID, for at hente dine data fra PensionsInfo.
                                </p>
                                <ComponentsKreditdataRedirectButton inputId="pensionReportFile" flow='pensionsInfo'  size={ buttonSize }>
                                    { buttonText2 }
                                </ComponentsKreditdataRedirectButton>
                                { showHelpText &&
                                    <>
                                        <Spacer/>
                                        <p>Oplever du problemer? Kontakt os venligst på <a style={{ display:'inline' }} href={ 'mailto:kontakt@penly.dk' }> kontakt@penly.dk </a> og undlad at prøve at hente pensionsoplysninger igen.</p>
                                        <p>Du kan køre vores analyse igen ved at genindlæse seneste PensionsInfo dokument.</p>
                                        <Button size='tiny'  onClick={ refetchPensionsInfoFromUniify } variant="outline" className="noshadow">Genindlæs seneste pensionsinfo</Button>
                                    </>
                                }
                                { scraperIntegration &&
                                <>
                                    <p style={{ marginTop: 20 }}>
                                        Hvis du hellere vil hente rapporten fra PensionsInfo som PDF, og uploade den i Penly, så har du også mulighed for det.<br/>
                                        <a style={{ marginTop: 16 }} href={ Routes.PensionsinfoUploadGuide }>Se hvordan her.</a>
                                    </p>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '100%', paddingTop: 14 }}>
                                        <UploadButton onFilesChoosenHandler={ e => onFilesChoosenHandler(e) } style={{ minWidth: 121 }} acceptMimeTypes="application/pdf" inputId="pensionReportFile" size="tiny" variant="outline" className="noshadow">
                                            Upload PDF
                                        </UploadButton>
                                    </div>
                                </>

                                }

                            </div>
                        ) : (
                            <div style={{ marginTop: 20, marginBottom: 20 }}>
                                { canUseUniify?.reason?.status === 'IN_PROGRESS' ?
                                    <>
                                        <p>Du har startet indhæntning af pensionsoplysninger (ID: { canUseUniify.reason.customer_id }).</p>
                                        <Button size='tiny'  onClick={ refetchPensionsInfoFromUniify } variant="outline" className="noshadow">Fortsæt indhentning</Button>

                                        <Spacer/>
                                        <p>Oplever du problemer? Kontakt os venligst på <a style={{ display:'inline' }} href={ 'mailto:kontakt@penly.dk' }> kontakt@penly.dk </a></p>
                                        <p>Du kan køre vores analyse igen ved at genindlæse seneste PensionsInfo dokument.</p>
                                    </>:
                                    <p>
                                        <p>Du har tidligere hentet pensionsoplysninger (ID: { canUseUniify.reason.customer_id }).</p>

                                        Du kan hente nye pensionsoplysninger med MitID igen om <strong>{ daysUntilExpiration } </strong>dage.
                                        { scraperIntegration &&
                                        <>
                                            Indtil da har du mulighed for at hente rapporten fra PensionsInfo som PDF, og uploade den i Penly.
                                            <a style={{ marginTop: 16 }} href={ Routes.PensionsinfoUploadGuide }>Se hvordan her.</a>
                                        </>

                                        }
                                        { showHelpText &&
                                        <>
                                            <Spacer/>
                                            <p>Oplever du problemer? Kontakt os venligst på <a style={{ display:'inline' }} href={ 'mailto:kontakt@penly.dk' }> kontakt@penly.dk </a></p>
                                            <p>Du kan køre vores analyse igen ved at genindlæse seneste PensionsInfo dokument.</p>
                                            <Button size='tiny'  onClick={ refetchPensionsInfoFromUniify } variant="outline" className="noshadow">Genindlæs seneste pensionsinfo</Button>
                                        </>
                                        }


                                    </p>
                                }

                                { scraperIntegration &&
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '100%', paddingTop: 14 }}>
                                        <UploadButton onFilesChoosenHandler={ e => onFilesChoosenHandler(e) } style={{ minWidth: 121 }} acceptMimeTypes="application/pdf" inputId="pensionReportFile" size="tiny" variant="outline" className="noshadow">
                                            Upload PDF
                                        </UploadButton>
                                    </div>
                                }

                            </div>
                        )
                    ) : (
                        scraperIntegration ?
                            <div style={{ marginTop: 20, marginBottom: 20, display: 'flex', flexDirection: 'column' }}>
                                <p>
                                    Du kan hente nye oplysninger ved at downloade en PDF fra PensionsInfo, som du derefter kan uploade til Penly.<br/>
                                    <a style={{ marginTop: 16 }} href={ Routes.PensionsinfoUploadGuide }>Se hvordan her.</a><br/>
                                </p>
                                <UploadButton onFilesChoosenHandler={ e => onFilesChoosenHandler(e) } acceptMimeTypes="application/pdf" inputId="pensionReportFile" size={ buttonSize } variant="outline" className="noshadow">
                                    Upload ny rapport
                                </UploadButton>
                            </div>:
                            <div>
                                Det er desværre ikke muligt at hente PensionsInfo lige nu. Kontakt os for mere information.
                            </div>


                    ) }
                </>
            }
        />
    );
};

UploadPensionModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
};

export default UploadPensionModal;
